import { AppConfig } from "../../../app/AppConfig";
import type {
  Address,
  Gender,
} from "../../../core/backend/clients/backendClient";

export class User {
  id: number = 0;
  email: string = "";
  name: string = "";
  birthDate?: Date;
  gender?: Gender;
  ssn?: string;
  ssnConsent?: boolean;
  address?: Address;
  phone?: string;

  expiresAt?: Date;
  token?: string;
  isLoggedIn: boolean = false;

  get info(): string {
    return this.name + (AppConfig.production ? "" : ` (${this.id})`);
  }

  constructor(init?: Partial<User>) {
    if (init) Object.assign(this, init);
  }
}
